/**
 * Returns a list with auxiliaries for the Polish passive voice assessment.
 * @returns {Array} The list with auxiliaries.
 */
export default function() {
	return [
		"być",
		"jestem",
		"jesteś",
		"jest",
		"jesteśmy",
		"jesteście",
		"są",
		"byłam",
		"byłem",
		"byłeś",
		"byłaś",
		"był",
		"była",
		"było",
		"byłoby",
		"byliśmy",
		"byłyśmy",
		"byliście",
		"byłyście",
		"byli",
		"były",
		"będę",
		"będziesz",
		"będzie",
		"będziemy",
		"będziecie",
		"będą",
		"byłabym",
		"byłbym",
		"byłbyś",
		"byłabyś",
		"byłaby",
		"byłby",
		"bylibyśmy",
		"byłybyśmy",
		"bylibyście",
		"byłybyście",
		"byłby",
		"byłaby",
		"byliby",
		"byłyby",
		"zostać",
		"zostaje",
		"zostajesz",
		"zostaję",
		"zostajecie",
		"zostajemy",
		"zostają",
		"zostanę",
		"zostaniesz",
		"zostanie",
		"zostaniemy",
		"zostaniecie",
		"zostaną",
		"zostałem",
		"zostałam",
		"zostałaś",
		"zostałeś",
		"został",
		"została",
		"zostało",
		"zostaliśmy",
		"zostałyśmy",
		"zostaliście",
		"zostałyście",
		"zostali",
		"zostały",
		"zostałbym",
		"zostałabym",
		"zostałbyś",
		"zostałabyś",
		"zostałby",
		"zostałaby",
		"zostałybyśmy",
		"zostalibyśmy",
		"zostalibyście",
		"zostałybyście",
		"zostaliby",
		"zostałyby",
	];
}
